export default __webpack_public_path__ + "842660103ff03602d63a7c7a66678434.png";